import { buildEncodedLocationSrpPathSegment } from './build-encoded-location-srp-path-segment';
import type { LocationLocale } from './generate-localized-location-url';
import { JOBS_LISTING_SEGMENT } from '../constants/url-constants';

/**
 * Builds a locale-relative `/jobs/location/{slug}`-style path for a location SRP link (no
 * BASE_URL prefix — for use with the <Link> component, which prepends the app's own origin).
 * Same segment names as the JSON-LD significantLink URLs in useMarketHeaderData's structuredData.
 *
 * Pass `categorySlug` to build the combined `/jobs/location/{slug}/category/{categorySlug}`
 * sub-query path — `match-search-index-path.ts` parses location before category, so this order
 * is required for the route to resolve.
 */
export function buildLocationSrpPath(
  locationSlug: string,
  locale: LocationLocale,
  categorySlug?: string,
  /** Role hub slug for the role x city page (`/jobs/location/{slug}/role/{roleSlug}`). */
  roleSlug?: string,
): string {
  const locationSegment = locale === 'fi' ? 'alue' : locale === 'sv' ? 'omrade' : 'location';
  const jobsSegment = JOBS_LISTING_SEGMENT[locale];
  const categorySegment = locale === 'fi' ? 'kategoria' : locale === 'sv' ? 'kategori' : 'category';
  const roleSegment = locale === 'fi' ? 'ammatti' : locale === 'sv' ? 'yrke' : 'role';
  const encodedSlug = buildEncodedLocationSrpPathSegment(locationSlug, locale);
  let path = `/${jobsSegment}/${locationSegment}/${encodedSlug}`;
  // match-search-index-path.ts parses location, then category, then role: keep that order.
  if (categorySlug) path += `/${categorySegment}/${categorySlug}`;
  if (roleSlug) path += `/${roleSegment}/${roleSlug}`;
  return path;
}
